"use client";
import AppLayout from "@/components/app/applayout";
import SocialContact from "@/components/consultation/contact";
import InputForm from "@/components/contact/form";
import { AppSize, pxToRem } from "@/util";
import { Box } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import Banner from "@/components/contact/banner";
import ContactUsMap from "@/components/map/contactusMap";

export default function Contact() {
  const { classes } = styles();
  return (
    <AppLayout>
      <Box className={`${classes.container}`}>
        <Banner />
        <Box className={`${classes.inputContact}`}>
          <Box>
            <InputForm />
          </Box>
          <Box>
            <SocialContact />
          </Box>
        </Box>
        <Box className={classes.map}>
          <Box className={classes.subMap}>
            <ContactUsMap />
          </Box>
        </Box>
      </Box>
    </AppLayout>
  );
}
const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    minHeight: pxToRem(500),
  },
  debug: {
    border: "1px solid green",
  },
  inputContact: {
    display: "grid",
    gridTemplateColumns: "1.8fr 1fr",
    minHeight: pxToRem(600),
    padding: `${pxToRem(40)} ${pxToRem(AppSize.padding)}`,
    gap: theme.spacing(4),
    alignSelf: "center",
    justifySelf: "center",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(4),
      padding: `${theme.spacing(4)} ${pxToRem(20)}`,
    },
    [theme.breakpoints.down("md")]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  map: {
    minHeight: pxToRem(500),
    position: "relative",
    padding: `20px ${pxToRem(AppSize.padding)}`,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(4)} ${pxToRem(20)}`,
    },
  },
  subMap: {
    flex: 1,
    position: "relative",
  },
}));
